/**
 * Created by Administrator on 2017/7/2.
 */

import {SHOWCAROUSEL} from './actionTypes.js';

export default (state = {}, action) => {
    switch (action.type) {
        case SHOWCAROUSEL: {
            let result = {};
            // console.log(Object.assign(result,state,{
            //     topBlogList: action.carouselBlogList
            // }));
            return Object.assign(result, state, {
                topBlogList: action.carouselBlogList
            });
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/Component/MyCarousel/reducer.js